"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_1 = require("../any/is-missing");
const is_object_1 = require("./is-object");
/**
 * Determine if the given object is present. The object is considered present
 * if it either has properties, or is an instance with inherited properties.
 *
 * @Param {T} value - The value to check for presence.
 *
 * @Example
 *
 *   isPresent({})
 *   //=> false
 *
 *   isPresent({ foo: 'bar' })
 *   //=> true
 *
 *   isPresent(new Date())
 *   //=> true
 */
function isPresent(value) {
    if (is_missing_1.isMissing(value)) {
        return false;
    }
    if (is_object_1.isObject(value) && value.constructor === Object) {
        return Object.keys(value).length > 0;
    }
    return Object.getOwnPropertyNames(Object.getPrototypeOf(value)).length > 0;
}
exports.isPresent = isPresent;
//# sourceMappingURL=is-present.js.map